import React, { useState } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import { sendGenericError } from '@disco/state-management/actions/error-actions'
import { updateBusinessSettings } from '@disco/state-management/actions/UserActions'
import { getBusinessSettings } from '@disco/state-management/selectors/user'
import { parseServerError } from '@disco/utils/captureError'
import Alert from 'components/ui/alert'
import ModalDialog from 'components/ui/modal-dialog'
import Stack from 'components/ui/stack'
import { partners } from './partners'

const PrivacyPolicyDialog = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { partner_source } = useSelector(getBusinessSettings)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { title, description } =
    partners[partner_source?.toLowerCase() ?? ''] || {}

  const onSubmit = async () => {
    setSubmitting(true)

    try {
      await dispatch(
        updateBusinessSettings(
          {
            // TODO: BE + FE, update if supported more then one partner_source
            // @ts-expect-error
            tidal_privacy_policy_accepted: true,
          },
          false,
        ),
      )
      navigate('/')
    } catch (error) {
      setError(parseServerError(error?.body?.[0] || error?.body || error))
      dispatch(sendGenericError(error))
    }

    setSubmitting(false)
  }

  return (
    <ModalDialog
      title={title}
      width="large"
      primaryAction={{
        caption: 'Ok',
        onClick: onSubmit,
        progressCaption: 'Submitting',
        progressIndicator: submitting,
      }}
      notClosable
    >
      <Stack space="xsmall">
        {error && (
          <div>
            <Alert status="danger" icon="warning">
              {String(error)}
            </Alert>
          </div>
        )}
        <div>{description}</div>
      </Stack>
    </ModalDialog>
  )
}

export default PrivacyPolicyDialog
